var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"s-inplace-progressbar"},[_c('div',{staticClass:"s-inplace-progressbar-content",style:(_vm.styles)},[(_vm.infinity)?_c('div',{staticClass:"dot"}):_vm._e()])])}
var staticRenderFns = []

export { render, staticRenderFns }